/**
 * 상신 후 참조인 추가(사후 참조) 가능 여부 판정.
 *
 * 상세 화면(하단 ReadersSlot 버튼 / 더보기 ActionMenu)과 목록 벌크 액션이 같은 조건을 쓰도록
 * 한 곳에 모았다.
 */

import type { ApprovalSecurityLevel } from '@/types/approval';

/** 문서 상태 — 상세는 DocumentStatus 유니온, 목록 응답은 string 이라 판정 인자는 string 으로 받는다. */
type DocumentStatusCode = 'S' | 'P' | 'H' | 'C' | 'D' | 'R' | 'X';

/**
 * 참조인을 사후 추가할 수 있는 문서 상태 — P(진행중)·H(보류)·C(완료)·R(반려).
 * S(임시저장)는 아직 상신 전이라 참조인 개념이 없고, D(삭제)는 대상이 아니라 빠진다.
 */
const REFERRER_ADDABLE_STATUSES: readonly DocumentStatusCode[] = [
  'P',
  'H',
  'C',
  'R',
];

/** 공개레벨 9(비공개) = 작성 시 '상신 후 참조인 추가 불가'를 체크한 문서. */
export const REFERRER_RESTRICTED_SECURITY: ApprovalSecurityLevel = 9;

export const isReferrerAddableStatus = (status: string): boolean =>
  (REFERRER_ADDABLE_STATUSES as readonly string[]).includes(status);

/**
 * 상태 + 공개레벨을 함께 보는 판정. 목록 API 응답에는 `security` 가 없어 상세에서만 쓸 수 있다.
 * 역할(작성자/결재자) 조건은 없다 — 문서를 볼 수 있으면 추가할 수 있다.
 */
export const canAddReferrer = (doc: {
  status: string;
  security?: number | null;
}): boolean =>
  isReferrerAddableStatus(doc.status) &&
  doc.security !== REFERRER_RESTRICTED_SECURITY;
